import React from 'react';
import topBanner from '../assests/img/top-banner.jpeg';

function TopBanner() {
  return (
    <section className="ma-top-banner" aria-label="MobileAcc Expo hero banner">
      <img
        className="ma-top-banner-img"
        src={topBanner}
        alt="MobileAcc Expo – Mobile & Accessories Exhibition, 08-10 August 2026, Bharat Mandapam, New Delhi"
      />
    </section>
  );
}

export default TopBanner;
